import {navigateHook} from "../../../../../hooks/use-navigate.js";

export default function ReportContent({ data }) {
    const navigate = navigateHook();

    return (
        <>
            <table
                id="garrison-km-check-data"
                className="table report-table"
                sheet-name="Verificação de km inconsistente"
            >
                <thead className="thead-background">
                    <tr className="bg-[#f6f6f6] text-left">
                        <th className="w-[70%]">Guarnição</th>
                        <th className="w-[15%]">Km inicial</th>
                        <th className="w-[15%]">Km final</th>
                    </tr>
                </thead>
                <tbody className="bg-white">
                {data.garrison.map((element, index) => {
                    return (
                        <tr key={element.garrisonid ?? index}>
                            <td>
                                <a onClick={() => navigate(`/despacho/garrison/form/${element.garrison_id}`, true)} className="report-link">
                                    {element.name ?? ""}
                                </a>
                            </td>
                            <td>{element.initialmileage ?? ""}</td>
                            <td>{element.finalmileage ?? ""}</td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
            <table
                id="dispatch-km-check-data"
                className="table report-table"
                sheet-name="Verificação de km inconsistente"
            >
                <thead className="thead-background">
                    <tr className="bg-[#f6f6f6] text-left">
                        <th className="w-[25%]">Número do talão</th>
                        <th className="w-[25%]">D/H inicial</th>
                        <th className="w-[50%]">Guarnição</th>
                    </tr>
                </thead>
                <tbody className="bg-white">
                    {data.dispatch.map((element, index) => {
                        return (
                            <tr key={element.dispatch_id ?? index}>
                                <td>
                                    <a onClick={() => navigate(`/despacho/dispatch/form/${element.dispatch_id}`, true)} className="report-link">
                                        {element.dispatch_numbercheckbook ?? "Sem talão"}
                                    </a>
                                </td>
                                <td>{element.dispatch_start}</td>
                                <td>
                                    <a onClick={() => navigate(`/despacho/garrison/form/${element.garrison_id}`, true)} className="report-link">
                                        {element.name ?? ""}
                                    </a>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            <div id="chart-tables" />
        </>
    )
}